import { createFileRoute } from '@tanstack/react-router';
import { AccountFormWrapper } from '@/pages/accounts/form-account';
import { PROTECTED, ACCOUNTS } from '@/lib/constants/routes';
import { createSheetRouteOptions } from '@/components/molecules/sheet-view-loader/route-helpers';

const RETURN_URL = `${PROTECTED}${ACCOUNTS}`;

export const Route = createFileRoute('/protected/_layout/accounts/_layout/new')(
  {
    ...createSheetRouteOptions(RETURN_URL),
    component: NewAccountModal,
  }
);

function NewAccountModal() {
  return <AccountFormWrapper returnUrl={RETURN_URL} />;
}
